import { useContext,useEffect } from "react";
import { GlobalProvider } from "../Context/GlobalState";
import { GlobalContext } from "../Context/GlobalState";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./Home.css";
import Card from "../Components/Card";
export default function Home() {
  const {
    user,
    raporTurleri,
    isLogin,
    API_URL,
    munavebeler,
    setMunavebeler,
    avukatlar,
    setAvukatlar,
    kayitliBilirkisiler,
    setKayitliBilirkisiler,
    setBilirkisi,
    // munavebeler,setMunavebeler
  } = useContext(GlobalContext);
  const navigate = useNavigate();

    const dbdenAvukatlariAl = (user) => {
      try {
        axios
          .post(API_URL + "/avukatgetir", { user })
          .then((response) => {
            console.log("cevap",response);
            console.log("avukatlara kaydedilen",response.data);
            setAvukatlar(response.data);
          })
          .catch((error) => {
            //alert("Bir Sorun var");
            console.error("There was an error!", error);
          });
      } catch (error) {}
    };
    const dbdenBilirkisileriAl = (user) => {
      try {
        axios
          .post(API_URL + "/bilirkisigetir", { user })
          .then((response) => {
            setBilirkisi(response.data);
            var bilirkisiarray = [];
            response.data.map((item) => {
              return bilirkisiarray.push(JSON.parse(item.name));
            });
            console.log(bilirkisiarray);
            setKayitliBilirkisiler(bilirkisiarray);
          })
          .catch((error) => {
            //alert("Bir Sorun var");
            console.error("There was an error!", error);
          });
      } catch (error) {}
  };
  
    const dbdenMunavebeAl = async (user) => {
      try {
        await axios
          .post(API_URL + "/munavebegetir", { user })
          .then((response) => {
            console.log("object :>> ", response);
            setMunavebeler(response.data);
          })
          .catch((error) => {
            window.alert("Bir Sorun var");
            //console.error("There was an error!", error.data);
          });
      } catch (error) {}
    };

    useEffect(() => {
      try {
        avukatlar === false && dbdenAvukatlariAl(user);
        kayitliBilirkisiler === false && dbdenBilirkisileriAl(user);
        munavebeler.length < 1 && dbdenMunavebeAl(user);
      } catch (error) {}

      //
      //setDavaTarihi("2024-04-25");
    }, [user]);

  return (
    <GlobalProvider>
     {isLogin?<div className="container">
  <div className="row justify-content-center">
    {raporTurleri.map((rapor, index) => {
      return (
        <div
          className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
          key={index}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Card
            key={index}
            id={index}
            name={rapor.name}
            img={rapor.img}
            desc={rapor.desc}
            link={rapor.link}
          />
        </div>
      );
    })}
  </div>
      </div>:navigate("/")}
    </GlobalProvider>
  );
}
